import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ApiRoutes } from "src/app/shared/app/routers/ApiRoutes";
import { IUser, LoginResponse, UserAccess } from "../models/iuser";
import { IBaseResponse } from "src/app/shared/app/models/App/IBaseResponse";
import { localStorageKeys } from "../models/localStorageKeys";
import { JwtHelperService } from "@auth0/angular-jwt";
import { PermissionsService } from "./permissions.service";
import { Router } from "@angular/router";
import { AppRoutes } from "src/app/shared/app/routers/appRouters";
import { tap } from "rxjs/operators";
import { MessagesService } from "src/app/shared/services/messages.service";
import { MsalService } from "@azure/msal-angular";

@Injectable({ providedIn: "root" })

/**
 * Auth-service Component
 */
export class AuthenticationService {
  private readonly env: string = environment.baseURL;
  jwtHelper = new JwtHelperService();

  constructor(
    private http: HttpClient,
    private perm: PermissionsService,
    private router: Router,
    private message: MessagesService,
    private msalService: MsalService,
  ) {}

  login(
    data: IUser | { token: string; connectTo: string; returnUrl: string } | any,
  ): Observable<IBaseResponse<LoginResponse>> {
    const headers = new HttpHeaders({
      "Connect-To": data.connectTo!,
    });
    return this.http
      .post<
        IBaseResponse<LoginResponse>
      >(this.env + ApiRoutes.Users.login, data, { headers })
      .pipe(
        tap((res) => {
          if (res.status) {
            localStorage.setItem(localStorageKeys.JWT, res.data?.accessToken!);
            localStorage.setItem(
              localStorageKeys.Refresh,
              res.data?.refreshToken!,
            );
            this.message.toast("Logged In Successfully", "success");
          } else this.message.toast(res.message!, "error");
        }),
      );
  }
  /**
   * Logout the user
   */
  logout(): void {
    localStorage.removeItem(localStorageKeys.MT);
    localStorage.removeItem(localStorageKeys.JWT);
    localStorage.removeItem(localStorageKeys.Refresh);

    this.perm.clearPermissions();
    this.msalService.instance.clearCache();

    this.router.navigate([AppRoutes.Auth.login]);
  }

  logoutWithRevoke() {
    // logout the user
    this.revokeToken()
      .toPromise()
      .then(() => {
        this.logout();
      })
      .catch(() => this.logout());
  }

  revokeToken() {
    return this.http.post(this.env + ApiRoutes.Users.revoke, {
      userId: this.decodeToken.UserId,
      refreshToken: localStorage.getItem(localStorageKeys.Refresh),
    });
  }

  get currentToken(): string {
    return localStorage.getItem(localStorageKeys.JWT)!;
  }

  get currentMTToken(): string {
    return localStorage.getItem(localStorageKeys.MT)!;
  }

  get isTokenAvailabe(): boolean {
    return !!localStorage.getItem(localStorageKeys.JWT);
  }
  get isMTTokenAvailabe(): boolean {
    return !!localStorage.getItem(localStorageKeys.MT);
  }

  get decodeToken(): UserAccess {
    return this.jwtHelper.decodeToken(
      localStorage.getItem(localStorageKeys.JWT)!,
    )!;
  }

  changePassword(password: string): Observable<IBaseResponse<number>> {
    return this.http.post<IBaseResponse<number>>(
      this.env + ApiRoutes.Users.changePassword,
      {
        userName: this.getUser().name,
        password: password,
        emailPassword: "",
      },
    );
  }

  getUser(): UserAccess {
    return this.decodeToken;
  }
}
